import styled from 'styled-components';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const DatePickerRangeFieldStyled = styled.div`
  display: flex;

  > ${Box} {
    flex: 1;
  }

  input {
    width: 100%;
  }

  > ${Box}:first-child {
    padding-right: ${rem(spacing8)};
  }
  > ${Box}:last-child {
    padding-left: ${rem(spacing8)};
  }
`;
